import { render, staticRenderFns } from "./VendorManagementRequestChart.vue?vue&type=template&id=4753c49f"
import script from "./VendorManagementRequestChart.vue?vue&type=script&lang=js"
export * from "./VendorManagementRequestChart.vue?vue&type=script&lang=js"
import style0 from "./VendorManagementRequestChart.vue?vue&type=style&index=0&id=4753c49f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports